/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: LanguagesTab.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.02.23 5:39 pm.
 * Last modified: 06.02.23 5:39 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../../api/helpers';
import { useSettings } from '../../contexts/SettingsContext';
import { useTranslator } from '../../contexts/TranslatorContext';

const LanguagesTab = () => {
    const [settings, setSettings] = useSettings();
    const translate = useTranslator();

    const setLanguage = (languageCode: string) => () => {
        setSettings?.({ ...settings, languageCode });
    };

    return (
        <div className="egt_lobby_settings_languages_container">
            {settings.supportedLanguages.map(languageCode => {
                return (
                    <div className="egt_lobby_language_option" key={languageCode} onClick={setLanguage(languageCode)}>
                        <div>
                            <img
                                src={addBuildHash(
                                    `${settings.host}/assets/portal/flags/flag_${languageCode.toLowerCase()}.svg`,
                                )}
                                alt={languageCode}
                            />
                            <span className="label">{translate(languageCode.toLowerCase())}</span>
                        </div>
                        <div className="language_option_radio">
                            {settings.languageCode.toLowerCase() === languageCode.toLowerCase() && (
                                <div className="language_option_dot"></div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default LanguagesTab;
